import { atomWithReset } from "jotai/utils";

export type ArticleFloatingButtonAtom = {
  articleFloatingButton: Record<string, FloatingButtonConfig>;
};

export type FloatingButtonConfig = {
  hideLabelInMobile: boolean;
  isEnable: boolean;
  tooltipLabel: string;
  type: "link" | "popup";
  typeformLink: string;
};

export const defaultFloatingButtonAtom: ArticleFloatingButtonAtom = {
  articleFloatingButton: {},
};

export const articleFloatingButtonAtom = atomWithReset<ArticleFloatingButtonAtom>({
  articleFloatingButton: {},
});
